import { render, staticRenderFns } from "./ConvenzioneAlternanzaSign.vue?vue&type=template&id=a0e3c6da&scoped=true&"
import script from "./ConvenzioneAlternanzaSign.vue?vue&type=script&lang=ts&"
export * from "./ConvenzioneAlternanzaSign.vue?vue&type=script&lang=ts&"
import style0 from "./ConvenzioneAlternanzaSign.vue?vue&type=style&index=0&id=a0e3c6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e3c6da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VIcon,VRow})
